import React, { useState } from 'react';
import { BarChart3Icon, TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
type Notification = {
  id: string;
  event: string;
  date: string;
  impact: 'high_negative' | 'medium_negative' | 'low_positive' | 'medium_positive' | 'high_positive';
  acknowledgedBy: string | null;
};
const notifications: Notification[] = [{
  id: '1',
  event: 'Financial statement filed: Revenue increased 15% YoY to $285M',
  date: '3/15/2026',
  impact: 'high_positive',
  acknowledgedBy: 'Sarah Chen'
}, {
  id: '2',
  event: "News article: Golden Ticket Promotion Drives Record Valentine's Day Sales",
  date: '2/14/2026',
  impact: 'high_positive',
  acknowledgedBy: 'Sarah Chen'
}, {
  id: '3',
  event: 'DBT decreased from 8 days to 5 days (37.5% improvement)',
  date: '2/01/2026',
  impact: 'high_positive',
  acknowledgedBy: 'Sarah Chen'
}, {
  id: '4',
  event: 'News article: Wonka Industries Expands Distribution to 12 New Countries',
  date: '1/05/2026',
  impact: 'high_positive',
  acknowledgedBy: 'Sarah Chen'
}];
function ImpactIndicator({
  impact
}: {
  impact: Notification['impact'];
}) {
  if (impact === 'high_negative') {
    return <div className="flex items-end gap-0.5 justify-center" data-id="element-4066" data-mp="3kmhebvl95rmy">
        <div className="w-1.5 h-2 bg-red-500 rounded-sm" data-id="element-4067" data-mp="3fp7cfggofni8" />
        <div className="w-1.5 h-3.5 bg-red-500 rounded-sm" data-id="element-4068" data-mp="2ryli0rzli1qp" />
        <div className="w-1.5 h-5 bg-red-500 rounded-sm" data-id="element-4069" data-mp="2rz3kw7grje7l" />
      </div>;
  }
  if (impact === 'medium_negative') {
    return <div className="flex items-end gap-0.5 justify-center" data-id="element-4070" data-mp="2nzcp1pcdq7w7">
        <div className="w-1.5 h-2 bg-red-500 rounded-sm" data-id="element-4071" data-mp="31yccwus2iirb" />
        <div className="w-1.5 h-3.5 bg-red-500 rounded-sm" data-id="element-4072" data-mp="2wx54qum0jhk4" />
        <div className="w-1.5 h-5 bg-gray-200 rounded-sm" data-id="element-4073" data-mp="2wzraqpt99p08" />
      </div>;
  }
  if (impact === 'low_positive') {
    return <div className="flex items-end gap-0.5 justify-center" data-id="element-4074" data-mp="c7phuapx0czr">
        <div className="w-1.5 h-2 bg-green-500 rounded-sm" data-id="element-4075" data-mp="c77fqxgkn4jx" />
        <div className="w-1.5 h-3.5 bg-gray-200 rounded-sm" data-id="element-4076" data-mp="k8wx3dl5td1z" />
        <div className="w-1.5 h-5 bg-gray-200 rounded-sm" data-id="element-4077" data-mp="o9qhhwze89q4" />
      </div>;
  }
  if (impact === 'medium_positive') {
    return <div className="flex items-end gap-0.5 justify-center" data-id="element-4078" data-mp="t8jyhzdw2iv1">
        <div className="w-1.5 h-2 bg-green-500 rounded-sm" data-id="element-4079" data-mp="t70crt9grflv" />
        <div className="w-1.5 h-3.5 bg-green-500 rounded-sm" data-id="element-4080" data-mp="y7edeq8qjn9v" />
        <div className="w-1.5 h-5 bg-gray-200 rounded-sm" data-id="element-4081" data-mp="ko1etkeqoxq" />
      </div>;
  }
  // high_positive
  return <div className="flex items-end gap-0.5 justify-center" data-id="element-4082" data-mp="5ih95r1czr04">
      <div className="w-1.5 h-2 bg-green-500 rounded-sm" data-id="element-4083" data-mp="5gwabp80hlwg" />
      <div className="w-1.5 h-3.5 bg-green-500 rounded-sm" data-id="element-4084" data-mp="ahk42inmkgud" />
      <div className="w-1.5 h-5 bg-green-500 rounded-sm" data-id="element-4085" data-mp="f8seni0oy894" />
    </div>;
}
export function WonkaNotificationsTab() {
  const [selected, setSelected] = useState<Set<string>>(new Set());
  const toggleAll = () => {
    if (selected.size === notifications.length) {
      setSelected(new Set());
    } else {
      setSelected(new Set(notifications.map(n => n.id)));
    }
  };
  const toggleOne = (id: string) => {
    const next = new Set(selected);
    if (next.has(id)) {
      next.delete(id);
    } else {
      next.add(id);
    }
    setSelected(next);
  };
  return <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-4086" data-mp="31ijbjcrut5fs">
      <div className="p-5 border-b border-gray-200" data-id="element-4087" data-mp="2wh3ojf648our">
        <h3 className="text-lg font-bold text-gray-900" data-id="element-4088" data-mp="2sg0bt1jd78xr">Notifications</h3>
      </div>
      <div className="overflow-x-auto" data-id="element-4089" data-mp="2npbhzfk7pzvg">
        <table className="w-full text-sm text-left" data-id="element-4090" data-mp="2nngze7weyjuj">
          <thead className="bg-gray-50 text-gray-500 border-b border-gray-200" data-id="element-4091" data-mp="2ipp5x9g4epo8">
            <tr data-id="element-4092" data-mp="2inmb8c40w8d6">
              <th className="px-5 py-3 w-10" data-id="element-4093" data-mp="2dr479egioe1w">
                <input type="checkbox" checked={selected.size === notifications.length} onChange={toggleAll} className="w-4 h-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 cursor-pointer" data-id="element-4094" data-mp="2dsfc7hlp7rul" />
              </th>
              <th className="px-5 py-3 font-medium" data-id="element-4095" data-mp="2tiwu9heujmmi">Event</th>
              <th className="px-5 py-3 font-medium text-center w-32" data-id="element-4096" data-mp="2yevb8jxui2cw">Date</th>
              <th className="px-5 py-3 font-medium text-center w-24" data-id="element-4097" data-mp="2kp1n63u5zm48">Impact</th>
              <th className="px-5 py-3 font-medium text-center w-40" data-id="element-4098" data-mp="2oq3pwunaigay">
                Acknowledged By
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200" data-id="element-4099" data-mp="2apkgpk739477">
            {notifications.map(n => <tr key={n.id} className="hover:bg-gray-50 transition-colors" data-id="element-4100" data-mp="2fq88i8355p2h">
                <td className="px-5 py-4" data-id="element-4101" data-mp="21qfoevm4e73h">
                  <input type="checkbox" checked={selected.has(n.id)} onChange={() => toggleOne(n.id)} className="w-4 h-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 cursor-pointer" data-id="element-4102" data-mp="21rqpuos3f2rf" />
                </td>
                <td className="px-5 py-4 text-gray-900" data-id="element-4103" data-mp="1ohwy8yakokt5">{n.event}</td>
                <td className="px-5 py-4 text-gray-500 text-center whitespace-nowrap" data-id="element-4104" data-mp="1oi6q6rf6h21h">
                  {n.date}
                </td>
                <td className="px-5 py-4 text-center" data-id="element-4105" data-mp="1y7qbe3qd57zi">
                  <ImpactIndicator impact={n.impact} data-id="element-4106" data-mp="1y9b2tkhdsat5" />
                </td>
                <td className="px-5 py-4 text-gray-500 text-center" data-id="element-4107" data-mp="1tfyrgc1pq0ic">
                  {n.acknowledgedBy ?? '--'}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
      <div className="flex items-center justify-end gap-4 px-5 py-3 border-t border-gray-200 text-sm text-gray-500" data-id="element-4108" data-mp="2361hc3djeycg">
        <span data-id="element-4109" data-mp="2h5t34qaapj10">Rows per page: 5</span>
        <span data-id="element-4110" data-mp="2c7r95abbzzar">1–4 of 4</span>
        <div className="flex gap-1" data-id="element-4111" data-mp="2c8kjsmdev8y6">
          <button className="p-1 rounded hover:bg-gray-100 text-gray-400 cursor-not-allowed" data-id="element-4112" data-mp="2c8auz243r7u2">
            ‹
          </button>
          <button className="p-1 rounded hover:bg-gray-100 text-gray-400 cursor-not-allowed" data-id="element-4113" data-mp="hti0j6eygn3p">
            ›
          </button>
        </div>
      </div>
    </div>;
}